export interface CurrencyConversionGq {
  id: number;
  success: boolean;
  currencyLayerTimestamp: string;
  localTimestamp: string;
  source: string;
  quotes: string;
}

export const CurrencyConversionGqProps = `
  id
  success
  currencyLayerTimestamp
  localTimestamp
  source
  quotes
`;

export function ParseConversion(conversion?: CurrencyConversionGq, currency?: string): number {
  const parsedQuotes = JSON.parse(conversion?.quotes) as Record<string, number>;
  return parsedQuotes[currency] ?? 1;
}